<template>
  <div class="body_monban">
    <el-tabs style="height: 200px;" v-model="activeName">
      <el-tab-pane label="门店规则参数" name="fenrun"  v-if="false">
        <fenrunGuize></fenrunGuize>
      </el-tab-pane>
      <!-- <el-tab-pane label="设备类型" name="macType"><macType></macType></el-tab-pane> -->
      <el-tab-pane label="城市维护" name="cheXingWeihu"    v-if="true">
        <chengshi></chengshi>
      </el-tab-pane>
      <el-tab-pane label="车型浏览" name="chexing"  v-if="false">
        <cheXing></cheXing>
      </el-tab-pane>
      <el-tab-pane label="车型选择" name="cheXing_select"  v-if="false">
        <cheXingSelect @getProductTypeSelectedUid="getProductTypeSelectedUid"></cheXingSelect>
      </el-tab-pane>
      <el-tab-pane label="服务单类型维护" name="product_Type"  v-if="false">
        <productType></productType>
      </el-tab-pane>
      <el-tab-pane label="图片管理" name="productType_Select" v-if="false">
        <pic></pic>
        <!-- 此处图片组件中，上传 和 更新到数据库是分离的，上传在子组件中完成，更新到数据由父组件调用，因为没有保存前，这些数据都有可能不需要保存 -->
     <!-- 数据返回直接由调用的存储过程返回图片uid参数 -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style>
.body_moban {
  padding-top: 100px;
}
</style>
<script>
import fenrunGuize from './fenrunGuize.vue'
import chengshi from '../../admin/chengshi/read.vue'
import cheXingWeihu from '../../tongyong/cheXingWeihu.vue'
import cheXingSelect from '../../tongyong/cheXing_select.vue'
import productType from '../../tongyong/productType.vue'
import productTypeSelect from '../../tongyong/productType_select.vue'
import pic from '../../tongyong/pic_com.vue'
// import macType from './macType.vue';
export default {
  components: {
    fenrunGuize: fenrunGuize,
    chengshi: chengshi,
    cheXingSelect: cheXingSelect,
    productType: productType,

    // productTypeSelect: productTypeSelect,
    pic: pic 
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'cheXingWeihu'

    };
  },
  props: [],

  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    getCarTypeSelectedUid(typeId) {
      // console.log(880, typeId)
    },
    getProductTypeSelectedUid(data) {
    //  console.log(881, data)
    },
    getPicUid(id) {
      console.log('pic', id)
    }
  }
}
</script>../../tongyong/cheXing_selectB.vue
